import type { V3SalesContact, V4SalesContact } from '@/apiTypes'
import type { SalesContact } from '@/types'

export const mapSalesContact = (
	V4SalesContact: V4SalesContact,
	V3SalesContact?: V3SalesContact
): SalesContact => {
	const organizationData = getOrganizationData(V4SalesContact)
	if (V3SalesContact) {
		delete V3SalesContact.funeralHomes
		return {
			...V3SalesContact,
			...organizationData,
			legalName: V4SalesContact.legalName,
		}
	} else {
		return {
			id: V4SalesContact.id,
			firstname: V4SalesContact.firstName,
			lastname: V4SalesContact.lastName,
			name: V4SalesContact.name,
			legalName: V4SalesContact.legalName,
			email: V4SalesContact.email,
			mobilePhone: V4SalesContact.mobilePhone,
			...organizationData,
		}
	}
}

const getOrganizationData = (V4SalesContact: V4SalesContact) => {
	return {
		isEverplansAuthorized: V4SalesContact.isEverplansAuthorized,
		producerNumbers: V4SalesContact.producerNumbers,
		licenses: V4SalesContact.licenses,
		presentationLicenses: V4SalesContact.licenses.data
			.find((item) => item.name === 'Sales Studio')
			?.salesStudioPresentation?.split(';'),
	}
}

export const mapSalesContactService = {
	mapSalesContact,
}
